import { CONFIG_LOAD_REQUEST } from '../constants/ActionTypes';

export const loadConfig = () => ({
  type: CONFIG_LOAD_REQUEST,
  payload: {}
});
